import React from 'react';
import { SiteSections } from './SiteSections';
import { ISiteSectionEntry } from '../../../../contentful/types/ISiteSection';
import { Wrapper } from './SiteSections.styles';
import { MainNavigation } from '../shared/MainNavigation';
import SearchButton from '../../button/SearchButton';
import { SearchButtonWrapper } from './DesktopNavigation.styles';

interface IProps {
	siteSections: ISiteSectionEntry[];
	siteSection?: ISiteSectionEntry;
	siteSectionId?: string;
	type: 'primary' | 'secondary';
	isSticky: boolean;
	onSiteSectionIdChange: (id: string) => void;
	displayTopSiteSectionNavigation?: boolean;
}

export default function DesktopNavigation({
	siteSections,
	siteSection,
	siteSectionId,
	type,
	isSticky,
	onSiteSectionIdChange,
	displayTopSiteSectionNavigation,
}: IProps) {
	return (
		<Wrapper>
			{displayTopSiteSectionNavigation && (
				<SiteSections
					siteSections={siteSections}
					currentSiteSectionId={siteSection?.fields.id}
					collapsed={isSticky}
					onSiteSectionIdChange={onSiteSectionIdChange}
				/>
			)}
			<SearchButtonWrapper>
				<SearchButton expanded={!isSticky} />
			</SearchButtonWrapper>

			{siteSection && (
				<MainNavigation
					items={siteSection.fields.menuItems}
					showBackground={isSticky}
					type={type}
					siteSectionId={siteSectionId}
				/>
			)}
		</Wrapper>
	);
}
